import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { AppFlowService } from "../services/app-flow/app-flow.service";

@Injectable({
  providedIn: "root",
})
export class DesktopScreenRouteGuard  {
  constructor(private router: Router, private appFlowService: AppFlowService) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    console.log("Desktop Route Guard --> ", state.url);
    const screenSize = window.innerWidth;
    if (screenSize <= 768) {
      console.log("Navigating to /m");
      return this.router.parseUrl(`/m`);
    }
    return true;
  }
}
